import React, { useState, useEffect } from 'react';
import VerticalBarChart from '../components/VerticalBarChart';
import rndIntensityByBusinessUnits from './rnd_intensity_by_business_units.service';
const RnDIntensity = _ref => {
  let {
    filteredBusinessUnits,
    selectedYears,
    selectedSubsidiaryCompanyIds,
    companyId
  } = _ref;
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const businessUnitsParam = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
        const yearsParam = selectedYears.join(',');
        const subsidiaryCompanyIdsParam = selectedSubsidiaryCompanyIds.join(',');
        const data = await rndIntensityByBusinessUnits.all(companyId, businessUnitsParam, yearsParam, subsidiaryCompanyIdsParam);
        const transformedData = Object.entries(data).map(_ref2 => {
          let [label, value] = _ref2;
          return {
            label,
            value: parseFloat(value)
          };
        });
        setChartData(transformedData);
      } catch (error) {
        console.error('Error fetching R&D Intensity data by subsidiary company:', error);
      }
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedYears, selectedSubsidiaryCompanyIds]);
  const percantegeFormatter = value => {
    return value + '%';
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card dashboard-card-group-chart"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title"
  }, "R&D Intensity"), /*#__PURE__*/React.createElement(VerticalBarChart, {
    data: chartData,
    groups: [],
    showLables: true,
    showLegend: false,
    dataName: "",
    formatter: percantegeFormatter,
    isPercentageData: true,
    colors: ['#00afef', '#0078b9', '#00b08b']
  }));
};
export default RnDIntensity;